import { FC, ReactElement } from "react";

import { Box, Grid, Stack } from "@mui/material";

import { MODAL_Z_INDEX } from "../constants";

import { DashboardDialog, DialogProps } from "@/dashboard-design-system/Dialog";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export type UserPermissionModalLayoutProps = {
  icon: ReactElement<unknown>;
  isOpen: boolean;
  onClose: () => void;
  isMFAStep: boolean;
  slots: {
    header: ReactElement<unknown>;
    userInputs?: React.ReactNode;
    campaignPermissions?: React.ReactNode;
    generalPermissions?: React.ReactNode;
    notifications?: React.ReactNode;
    errorMessage?: React.ReactNode;
    mfaStep?: React.ReactNode;
  };
  actions: NonNullable<DialogProps["actions"]>;
};

export const UserPermissionModalLayout: FC<UserPermissionModalLayoutProps> = ({
  isOpen,
  icon,
  onClose,
  isMFAStep,
  slots,
  actions,
}) => {
  const { isPhoneScreen } = useMediaQuery();

  const shouldHideActions = isMFAStep && !isPhoneScreen;

  return (
    <DashboardDialog
      data-test="user-permission-modal"
      open={isOpen}
      onClose={onClose}
      fullWidth
      fullScreenOnMobile
      maxWidth="sm"
      icon={icon}
      hideIcon={isPhoneScreen}
      sx={{
        zIndex: MODAL_Z_INDEX,
      }}
      slots={{
        title: slots.header,
      }}
      actions={{
        main: shouldHideActions ? { hidden: true } : actions.main,
        cancel: shouldHideActions ? { hidden: true } : actions.cancel,
      }}
    >
      <form noValidate>
        <Box sx={{ display: !isMFAStep ? "block" : "none" }}>
          <Stack direction="column" spacing={slots.userInputs ? 3 : 0}>
            {slots.userInputs}
            <Stack direction="column" spacing={3}>
              {slots.campaignPermissions}
              {slots.generalPermissions}
              {slots.notifications}
            </Stack>
            {slots.errorMessage}
          </Stack>
        </Box>
        <Box sx={{ display: isMFAStep ? "block" : "none" }}>
          <Grid container spacing={1}>
            <Grid item>{slots.mfaStep}</Grid>
          </Grid>
        </Box>
      </form>
    </DashboardDialog>
  );
};
